// extracted by mini-css-extract-plugin
module.exports = {"bubble":"NotAuthorized401_bubble__ot2b0","float":"NotAuthorized401_float__Ujoow"};